<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80" style="width: 300px" @mousedown.stop="" @click="dontClose">
          <div class="modal-body m-0" style="margin: auto;">
            <div class="col-12 px-0 px-md-2">
              <div class="">
                <b-row class="justify-content-start">
                  <b-col cols="12" v-if="caList == null">
                    <form-write-group-label-input  v-model="dataNameId.name"
                                                   :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col cols="12" v-if="caList != null">
                    <div>
                      <span class="filter-item-title">{{ $t('common.security.ca_select') }}</span>
                      <br>
                      <b-form-select v-model="dataNameId.id" :options="caList" style="font-size:small;">-- Please select an option --</b-form-select>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
          <div class="modal-footer m-0">
            <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
              <b-col cols="4" lg="4" xl="4">
                <b-button round class="button-action mx-2 mb-2" @click="$emit('close')">{{ $t('common.bck') }}</b-button>
              </b-col>
              <b-col cols="11" lg="11" xl="11">
                <b-button v-if="caList != null" class=" mx-2" variant="primary"
                          @click="save()">
                  <i class="fa-light fa-save"></i>
                  <span>{{ $t('common.security.link_truststore') }}</span>
                </b-button>
                <b-button v-else class=" mx-2" variant="primary"
                          @click="save()">
                  <i class="fa-light fa-save"></i>
                  <span>{{ $t('common.security.create_truststore') }}</span>
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'SecurityPopUp',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: ["caList"],
  data: () => {
    return {
      dataNameId: {
        name: '',
        id: '',
      }
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('click', this.handleClick)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  mounted () {
  },
  methods: {
    dontClose (e) {
      if (!e.target.closest('.modal-action')) {
        e.stopPropagation()
      }
    },
    handleClick (e) {
      if (e.target.closest('.modal-mask')) {
        this.$emit('close')
      }
    },
    save(){
      this.$emit('savepopup', this.dataNameId)
    }
  }
}
</script>
